import { parseData, post } from '../api/common';
import { responseHandler } from '../api/api';
const createSession = (ConnectionID, Issuer) => post('/InternalAPI/CardsGatewayAPI.asmx/CreateSession', {
    ConnectionID,
    Issuer
}).then(parseData);
const getDefaultCardholder = () => post('/InternalAPI/CardsGatewayAPI.asmx/GetDefaultCardHolder').then(parseData);
const setDefaultCardholder = (cardholder) => post('/InternalAPI/CardsGatewayAPI.asmx/SetDefaultCardHolder', {
    EmployeePK: cardholder.PK
}).then(parseData);
const getAccounts = () => post('/InternalAPI/CardsGatewayAPI.asmx/GetAccountsForCurrentCompany').then(parseData);
const getCardsByAccount = (AccountID) => post('/InternalAPI/CardsGatewayAPI.asmx/GetCardsByAccount', {
    AccountID
}).then(parseData);
const getGatewayCards = (UserEmail) => post('/InternalAPI/CardsGatewayAPI.asmx/GetGatewayCardsByUserEmail', {
    UserEmail
}).then(parseData);
const getSession = (ConnectionID) => {
    if (ConnectionID) {
        return post('/InternalAPI/CardsGatewayAPI.asmx/GetReconnectSessionForCurrentCompany', {
            ConnectionID
        }).then(parseData);
    }
    return post('/InternalAPI/CardsGatewayAPI.asmx/GetSessionForCurrentCompany').then(parseData);
};
const createConnection = (Issuer) => post('/InternalAPI/CardsGatewayAPI.asmx/CreateConnection', {
    Issuer
})
    .then(parseData)
    .then(responseHandler);
const deleteConnection = (CompanyGUID, ConnectionID) => post('/InternalAPI/CardsGatewayAPI.asmx/DeleteConnection', {
    CompanyGUID,
    ConnectionID
}).then(parseData);
const accountIsFullySynced = (ConnectionID) => post('/InternalAPI/CardsGatewayAPI.asmx/AccountIsFullySyncedByConnectionID', {
    ConnectionID
}).then(parseData);
const getConnection = (ConnectionID) => post('/InternalAPI/CardsGatewayAPI.asmx/GetConnectionForCurrentCompany', {
    ConnectionID
}).then(parseData);
const getAccount = (AccountID) => post('/InternalAPI/CardsGatewayAPI.asmx/GetAccountForCurrentCompany', {
    AccountID
}).then(parseData);
const getPCardsByAccount = (AccountID) => post('/InternalAPI/CardsGatewayAPI.asmx/GetPCardsByAccount', {
    AccountID
}).then(parseData);
const mapCard = (card, EmployeePK) => post('/InternalAPI/CardsGatewayAPI.asmx/MapCard', {
    card: JSON.stringify(card),
    EmployeePK
}).then(parseData);
const unmapCard = (card) => post('/InternalAPI/CardsGatewayAPI.asmx/UnmapCard', {
    card: JSON.stringify(card)
}).then(parseData);
export { accountIsFullySynced, createConnection, createSession, getAccounts, getCardsByAccount, getDefaultCardholder, getGatewayCards, getSession, setDefaultCardholder, deleteConnection, getConnection, getAccount, getPCardsByAccount, mapCard, unmapCard };
